import React from 'react';
import { Building2, Briefcase, Factory, School, GraduationCap, Landmark, Users, Heart } from 'lucide-react';
import { audiences } from '../data/mock';

const iconMap = {
  Building2: Building2,
  Briefcase: Briefcase,
  Factory: Factory,
  School: School,
  GraduationCap: GraduationCap,
  Landmark: Landmark,
  Users: Users,
  Heart: Heart
};

const Audiences = () => {
  return (
    <section id="audiences" className="py-16 sm:py-24 bg-slate-900">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-12 sm:mb-16">
          <span className="text-cyan-400 text-sm font-semibold tracking-widest uppercase mb-4 block">
            Who We Serve
          </span>
          <h2 className="text-2xl sm:text-3xl md:text-5xl font-bold text-white mb-4 sm:mb-6">
            Who We Support
          </h2>
          <p className="text-slate-400 text-base sm:text-lg max-w-3xl mx-auto">
            We partner with organizations of all types—businesses, schools, agencies, and community organizations—
            to develop people and strengthen performance.
          </p>
        </div>

        {/* Audiences Grid */}
        <div className="grid grid-cols-2 sm:grid-cols-4 gap-4 sm:gap-6">
          {audiences.map((audience, index) => {
            const IconComponent = iconMap[audience.icon];
            return (
              <div
                key={index}
                className="group p-5 sm:p-6 rounded-2xl bg-slate-950/50 border border-slate-800 hover:border-cyan-500/30 transition-all duration-300 text-center"
              >
                {/* Icon */}
                <div className="w-12 h-12 rounded-xl bg-white/5 flex items-center justify-center mx-auto mb-3 group-hover:bg-cyan-500/10 transition-colors">
                  <IconComponent className="h-6 w-6 text-slate-400 group-hover:text-cyan-400 transition-colors" />
                </div>

                {/* Name */}
                <h3 className="text-white font-medium text-sm sm:text-base group-hover:text-cyan-400 transition-colors">
                  {audience.name}
                </h3>
              </div>
            );
          })}
        </div>

        {/* Bottom Statement */}
        <div className="text-center mt-12">
          <p className="text-slate-400 text-sm sm:text-base">
            Wherever people need to grow, lead, and perform—we're here to help.
          </p>
        </div>
      </div>
    </section>
  );
};

export default Audiences;
